/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_9_0_0 = 'http://yapi.cai-inc.com/mock/6945' as any;
const devUrl_0_9_0_0 = '' as any;
const prodUrl_0_9_0_0 = '' as any;
const dataKey_0_9_0_0 = 'data' as any;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/588426) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/save`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummarySavePostRequest {
  /**
   * 工作总结编号
   */
  workSummaryFormCode?: string;
  /**
   * 编号-业务展示用
   */
  businessCode?: string;
  /**
   * 部门id
   */
  deptId: number;
  /**
   * 部门名称
   */
  deptName: string;
  /**
   * 日报时间
   */
  dailyTime: number;
  /**
   * 总结主题
   */
  title: string;
  /**
   * 工作总结内容
   */
  workSummary?: string;
  /**
   * 附件
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size: number;
    /**
     * 附件类型
     */
    type: string;
  }[];
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
    }[];
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/588426) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/save`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummarySavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/588426) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/save`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummarySavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/588426) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/save`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummarySavePostRequestConfig: ZlbApiExpenseWorkSummarySavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummarySavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/588426) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/save`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummarySavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummarySavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummarySavePostResponse>(
    prepare(zlbApiExpenseWorkSummarySavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummarySavePost.requestConfig = zlbApiExpenseWorkSummarySavePostRequestConfig;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/588434) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/submit`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummarySubmitPostRequest {
  /**
   * 工作总结编号
   */
  workSummaryFormCode?: string;
  /**
   * 编号-业务展示用
   */
  businessCode?: string;
  /**
   * 部门id
   */
  deptId: number;
  /**
   * 部门名称
   */
  deptName: string;
  /**
   * 日报时间
   */
  dailyTime: number;
  /**
   * 总结主题
   */
  title: string;
  /**
   * 工作总结内容
   */
  workSummary?: string;
  /**
   * 附件
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size: number;
    /**
     * 附件类型
     */
    type: string;
  }[];
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
    }[];
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/588434) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/submit`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummarySubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/588434) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/submit`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummarySubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/588434) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/submit`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummarySubmitPostRequestConfig: ZlbApiExpenseWorkSummarySubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummarySubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/588434) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/submit`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummarySubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummarySubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummarySubmitPostResponse>(
    prepare(zlbApiExpenseWorkSummarySubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummarySubmitPost.requestConfig = zlbApiExpenseWorkSummarySubmitPostRequestConfig;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/588442) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/delete`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryDeletePostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/588442) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/delete`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/588442) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/delete`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/588442) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/delete`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryDeletePostRequestConfig: ZlbApiExpenseWorkSummaryDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/588442) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/delete`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryDeletePostResponse>(
    prepare(zlbApiExpenseWorkSummaryDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryDeletePost.requestConfig = zlbApiExpenseWorkSummaryDeletePostRequestConfig;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/588450) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/list`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标题
   */
  title?: string;
  /**
   * 日报时间
   */
  dailyTime?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchStart?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchEnd?: number;
  /**
   * 状态
   */
  status?: number;
  /**
   * 编号
   */
  businessCode?: string;
  /**
   * 工作总结唯一单号
   */
  workSummaryFormCode?: string;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/588450) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/list`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 工作总结编号
       */
      workSummaryFormCode?: string;
      /**
       * 编号-业务展示用
       */
      businessCode?: string;
      /**
       * 日报时间
       */
      dailyTime?: number;
      /**
       * 总结主图
       */
      title?: string;
      /**
       * 状态
       */
      status?: number;
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 发起人ID
       */
      operatorId?: number;
      /**
       * 发起人姓名
       */
      operatorName?: string;
      /**
       * 发起人部门ID
       */
      deptId?: number;
      /**
       * 发起人部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      createTime?: number;
      /**
       * 最新修改时间
       */
      modifyTime?: number;
      /**
       * 操作按钮
       */
      buttonShowRO?: {
        /**
         * 查看按钮
         */
        isView?: boolean;
        /**
         * 编辑按钮
         */
        isEditor?: boolean;
        /**
         * 删除按钮
         */
        isDelete?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/588450) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/list`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/588450) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/list`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryListPostRequestConfig: ZlbApiExpenseWorkSummaryListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/588450) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/list`
 * @更新时间 `2023-12-11 21:35:46`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryListPostResponse>(
    prepare(zlbApiExpenseWorkSummaryListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryListPost.requestConfig = zlbApiExpenseWorkSummaryListPostRequestConfig;

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/588458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/detail`
 * @更新时间 `2023-12-12 09:42:53`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryDetailPostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/588458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/detail`
 * @更新时间 `2023-12-12 09:42:53`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作总结编号
     */
    workSummaryFormCode?: string;
    /**
     * 编号-业务展示用
     */
    businessCode?: string;
    /**
     * 操作人ID
     */
    operatorId?: number;
    /**
     * 操作人姓名
     */
    operatorName?: string;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门姓名
     */
    deptName?: string;
    /**
     * 日报时间
     */
    dailyTime?: number;
    /**
     * 标题
     */
    title?: string;
    /**
     * 工作总结内容
     */
    workSummary?: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 拒绝原因
     */
    rejectReason?: string;
    /**
     * 附件信息
     */
    zlbAttachmentROList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件类型
       */
      type?: string;
    }[];
    /**
     * 审批信息
     */
    workflowInfo?: {
      /**
       * 工作流的唯一key
       */
      workflowProcessKey?: string;
      /**
       * 工作流模型id
       */
      workflowModelId?: number;
      /**
       * 工作流版本
       */
      workflowVersion?: number;
      /**
       * 审核节点列表
       */
      auditNodeList?: {
        /**
         * 审核人列表
         */
        auditOperatorList?: {
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 审批意见
           */
          auditRemark?: string;
          /**
           * 审批状态：0-待审批，1-审批通过，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 签名附件
           */
          signAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 最新的个人历史签名附件
           */
          oneselfHistorySignAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
           */
          addAuditWay?: number;
          /**
           * 加签者
           */
          addAuditOperator?: string;
        }[];
        /**
         * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
         */
        userRangeType?: number;
        userRangeTypeNew?: number;
        /**
         * 动态审核人类型
         */
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        /**
         * 审核人数(总人数)
         */
        personCount?: number;
        /**
         * 审核状态：0-待审批，1-已审批，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 审核描述
         */
        auditDesc?: string;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳，3-抄送
         */
        eventType?: number;
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 节点key
         */
        nodeKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 策略
         * cn.gov.zcy.workflow.enums.CheckStrategyEnum
         */
        checkStrategy?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 机构
         */
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        /**
         * 常用审核人列表
         */
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        /**
         * 业务属性json
         */
        bizProperty?: string;
      }[];
      /**
       * 申请人操作人id
       */
      applyOperatorId?: number;
      /**
       * 申请人名称
       */
      applyOperatorName?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 申请备注
       */
      applyRemark?: string;
      /**
       * 是否能加签 0-否 1-是
       */
      isAddTaskAccess?: number;
      /**
       * 工作流是否开启签名：true-开启；false-未开启
       */
      isEnableSign?: boolean;
      /**
       * 签名配置：0-使用上次签名；1-每次重新签名；
       */
      signConfig?: number;
      /**
       * 实例当前节点业务属性
       */
      currentBizProperty?: string;
    };
    /**
     * 操作按钮权限
     */
    operateButton?: {
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/588458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/detail`
 * @更新时间 `2023-12-12 09:42:53`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/588458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/detail`
 * @更新时间 `2023-12-12 09:42:53`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryDetailPostRequestConfig: ZlbApiExpenseWorkSummaryDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/588458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/detail`
 * @更新时间 `2023-12-12 09:42:53`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryDetailPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryDetailPostResponse>(
    prepare(zlbApiExpenseWorkSummaryDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryDetailPost.requestConfig = zlbApiExpenseWorkSummaryDetailPostRequestConfig;

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/589106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryCancelPostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/589106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryCancelPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/589106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/589106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryCancelPostRequestConfig: ZlbApiExpenseWorkSummaryCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/589106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryCancelPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryCancelPostResponse>(
    prepare(zlbApiExpenseWorkSummaryCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryCancelPost.requestConfig = zlbApiExpenseWorkSummaryCancelPostRequestConfig;

/**
 * 接口 [工作流审批↗](http://yapi.cai-inc.com/project/6945/interface/api/589474) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/audit`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowAuditPostRequest {
  /**
   * 业务单号
   */
  bizId?: string;
  /**
   * 业务场景
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 审核意见
   */
  auditRemark?: string;
  /**
   * 审核状态：1-通过；2-驳回；
   */
  executeType: number;
  /**
   * 必填, 工作流类型Key
   */
  processDefineKey?: string;
  /**
   * 当前节点key
   */
  currentNodeKey: string;
  /**
   * 操作人
   */
  operatorId?: number;
  /**
   * 业务字段
   */
  context?: string;
  /**
   * 事件类型：0-审批，1-审核，2-出纳，3-抄送
   */
  eventType: number;
  /**
   * 签名附件
   */
  signAttachment?: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  };
}

/**
 * 接口 [工作流审批↗](http://yapi.cai-inc.com/project/6945/interface/api/589474) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/audit`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作流审批↗](http://yapi.cai-inc.com/project/6945/interface/api/589474) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/audit`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [工作流审批↗](http://yapi.cai-inc.com/project/6945/interface/api/589474) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/audit`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryWorkflowAuditPostRequestConfig: ZlbApiExpenseWorkSummaryWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作流审批↗](http://yapi.cai-inc.com/project/6945/interface/api/589474) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/audit`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryWorkflowAuditPostResponse>(
    prepare(zlbApiExpenseWorkSummaryWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryWorkflowAuditPost.requestConfig =
  zlbApiExpenseWorkSummaryWorkflowAuditPostRequestConfig;

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/6945/interface/api/589482) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowCancelPostRequest {
  bizId?: string;
  bizType?: string;
  subType?: string;
  /**
   * 可选, 备注：审批意见&撤回说明
   */
  remark?: string;
  operatorId?: number;
}

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/6945/interface/api/589482) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowCancelPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/6945/interface/api/589482) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryWorkflowCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/workflow/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/6945/interface/api/589482) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryWorkflowCancelPostRequestConfig: ZlbApiExpenseWorkSummaryWorkflowCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/workflow/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryWorkflowCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/6945/interface/api/589482) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/cancel`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryWorkflowCancelPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryWorkflowCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryWorkflowCancelPostResponse>(
    prepare(zlbApiExpenseWorkSummaryWorkflowCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryWorkflowCancelPost.requestConfig =
  zlbApiExpenseWorkSummaryWorkflowCancelPostRequestConfig;

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/590090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/repeat/check`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryRepeatCheckPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标题
   */
  title?: string;
  /**
   * 日报时间
   */
  dailyTime?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchStart?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchEnd?: number;
  /**
   * 状态
   */
  status?: number;
  /**
   * 编号
   */
  businessCode?: string;
  /**
   * 工作总结唯一单号
   */
  workSummaryFormCode?: string;
}

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/590090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/repeat/check`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryRepeatCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作总结编号
     */
    workSummaryFormCode?: string;
    /**
     * 编号-业务展示用
     */
    businessCode?: string;
    /**
     * 日报时间
     */
    dailyTime?: number;
    /**
     * 总结主图
     */
    title?: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 发起人ID
     */
    operatorId?: number;
    /**
     * 发起人姓名
     */
    operatorName?: string;
    /**
     * 发起人部门ID
     */
    deptId?: number;
    /**
     * 发起人部门名称
     */
    deptName?: string;
    /**
     * 发起时间
     */
    createTime?: number;
    /**
     * 最新修改时间
     */
    modifyTime?: number;
    /**
     * 操作按钮
     */
    buttonShowRO?: {
      /**
       * 查看按钮
       */
      isView?: boolean;
      /**
       * 编辑按钮
       */
      isEditor?: boolean;
      /**
       * 删除按钮
       */
      isDelete?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/590090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/repeat/check`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryRepeatCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/repeat/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/590090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/repeat/check`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryRepeatCheckPostRequestConfig: ZlbApiExpenseWorkSummaryRepeatCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/repeat/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryRepeatCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/590090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/repeat/check`
 * @更新时间 `2023-12-11 21:35:47`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryRepeatCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryRepeatCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryRepeatCheckPostResponse>(
    prepare(zlbApiExpenseWorkSummaryRepeatCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryRepeatCheckPost.requestConfig =
  zlbApiExpenseWorkSummaryRepeatCheckPostRequestConfig;

/**
 * 接口 [查询工作流模板↗](http://yapi.cai-inc.com/project/6945/interface/api/590114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequest {
  /**
   * 流程key
   */
  processDefineKey?: string;
  /**
   * 业务Id
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 金额
   */
  amount?: number;
  /**
   * 事项预算
   */
  eventBudget?: number;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: number;
  /**
   * 操作人
   */
  operatorId?: number;
  /**
   * 同行人
   */
  accompanyOperatorIds?: number[];
  /**
   * 是否派车，1-派车，2-不派车
   */
  arrangeCar?: string;
  /**
   * 差旅类型
   */
  travelType?: number;
}

/**
 * 接口 [查询工作流模板↗](http://yapi.cai-inc.com/project/6945/interface/api/590114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
         */
        addAuditWay?: number;
        /**
         * 加签者
         */
        addAuditOperator?: string;
      }[];
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 动态审核人类型
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳，3-抄送
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 策略
       * cn.gov.zcy.workflow.enums.CheckStrategyEnum
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 机构
       */
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      /**
       * 业务属性json
       */
      bizProperty?: string;
    }[];
    /**
     * 工作流的唯一key
     */
    workflowProcessKey?: string;
    /**
     * 工作流模型id
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询工作流模板↗](http://yapi.cai-inc.com/project/6945/interface/api/590114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/workflow/getTemplate',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询工作流模板↗](http://yapi.cai-inc.com/project/6945/interface/api/590114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequestConfig: ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/workflow/getTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryWorkflowGetTemplatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询工作流模板↗](http://yapi.cai-inc.com/project/6945/interface/api/590114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryWorkflowGetTemplatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryWorkflowGetTemplatePostResponse>(
    prepare(zlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryWorkflowGetTemplatePost.requestConfig =
  zlbApiExpenseWorkSummaryWorkflowGetTemplatePostRequestConfig;

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/6945/interface/api/590914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequest {
  /**
   * 业务标识
   */
  bizId: string;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 必填, 业务场景
   */
  bizType: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  remark?: string;
  /**
   * 业务上下文
   */
  context?: string;
  operatorId?: number;
}

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/6945/interface/api/590914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export interface ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/6945/interface/api/590914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
type ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/expense/work/summary/workflow/addCounterSign',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/6945/interface/api/590914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
const zlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequestConfig: ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_0,
    devUrl: devUrl_0_9_0_0,
    prodUrl: prodUrl_0_9_0_0,
    path: '/zlb/api/expense/work/summary/workflow/addCounterSign',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkSummaryWorkflowAddCounterSignPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/6945/interface/api/590914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [WorkSummaryController↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54231)
 * @请求头 `POST /zlb/api/expense/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-11 21:35:48`
 * @项目ID 6945
 */
export const zlbApiExpenseWorkSummaryWorkflowAddCounterSignPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkSummaryWorkflowAddCounterSignPostResponse>(
    prepare(zlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkSummaryWorkflowAddCounterSignPost.requestConfig =
  zlbApiExpenseWorkSummaryWorkflowAddCounterSignPostRequestConfig;

const mockUrl_0_9_0_1 = 'http://yapi.cai-inc.com/mock/6945' as any;
const devUrl_0_9_0_1 = '' as any;
const prodUrl_0_9_0_1 = '' as any;
const dataKey_0_9_0_1 = 'data' as any;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/601050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/save`
 * @更新时间 `2023-12-26 16:22:03`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummarySavePostRequest {
  /**
   * 工作总结编号
   */
  workSummaryFormCode?: string;
  /**
   * 编号-业务展示用
   */
  businessCode?: string;
  /**
   * 部门id
   */
  deptId: number;
  /**
   * 部门名称
   */
  deptName: string;
  /**
   * 日报时间
   */
  dailyTime: number;
  /**
   * 总结主题
   */
  title: string;
  /**
   * 工作总结内容
   */
  workSummary?: string;
  /**
   * 附件
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size: number;
    /**
     * 附件类型
     */
    type: string;
  }[];
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
    }[];
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/601050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/save`
 * @更新时间 `2023-12-26 16:22:03`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummarySavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/601050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/save`
 * @更新时间 `2023-12-26 16:22:03`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummarySavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/601050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/save`
 * @更新时间 `2023-12-26 16:22:03`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummarySavePostRequestConfig: ZlbApiOfficeWorkSummarySavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummarySavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存↗](http://yapi.cai-inc.com/project/6945/interface/api/601050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/save`
 * @更新时间 `2023-12-26 16:22:03`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummarySavePost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummarySavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummarySavePostResponse>(
    prepare(zlbApiOfficeWorkSummarySavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummarySavePost.requestConfig = zlbApiOfficeWorkSummarySavePostRequestConfig;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/601058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/submit`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummarySubmitPostRequest {
  /**
   * 工作总结编号
   */
  workSummaryFormCode?: string;
  /**
   * 编号-业务展示用
   */
  businessCode?: string;
  /**
   * 部门id
   */
  deptId: number;
  /**
   * 部门名称
   */
  deptName: string;
  /**
   * 日报时间
   */
  dailyTime: number;
  /**
   * 总结主题
   */
  title: string;
  /**
   * 工作总结内容
   */
  workSummary?: string;
  /**
   * 附件
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size: number;
    /**
     * 附件类型
     */
    type: string;
  }[];
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
    }[];
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/601058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/submit`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummarySubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/601058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/submit`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummarySubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/601058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/submit`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummarySubmitPostRequestConfig: ZlbApiOfficeWorkSummarySubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummarySubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/6945/interface/api/601058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/submit`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummarySubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummarySubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummarySubmitPostResponse>(
    prepare(zlbApiOfficeWorkSummarySubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummarySubmitPost.requestConfig = zlbApiOfficeWorkSummarySubmitPostRequestConfig;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/601066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/delete`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryDeletePostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/601066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/delete`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/601066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/delete`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/601066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/delete`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryDeletePostRequestConfig: ZlbApiOfficeWorkSummaryDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/6945/interface/api/601066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/delete`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryDeletePostResponse>(
    prepare(zlbApiOfficeWorkSummaryDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryDeletePost.requestConfig = zlbApiOfficeWorkSummaryDeletePostRequestConfig;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/list`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标题
   */
  title?: string;
  /**
   * 日报时间
   */
  dailyTime?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchStart?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchEnd?: number;
  /**
   * 状态
   */
  status?: number;
  /**
   * 编号
   */
  businessCode?: string;
  /**
   * 工作总结唯一单号
   */
  workSummaryFormCode?: string;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/list`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 工作总结编号
       */
      workSummaryFormCode?: string;
      /**
       * 编号-业务展示用
       */
      businessCode?: string;
      /**
       * 日报时间
       */
      dailyTime?: number;
      /**
       * 总结主图
       */
      title?: string;
      /**
       * 状态
       */
      status?: number;
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 发起人ID
       */
      operatorId?: number;
      /**
       * 发起人姓名
       */
      operatorName?: string;
      /**
       * 发起人部门ID
       */
      deptId?: number;
      /**
       * 发起人部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      createTime?: number;
      /**
       * 最新修改时间
       */
      modifyTime?: number;
      /**
       * 操作按钮
       */
      buttonShowRO?: {
        /**
         * 查看按钮
         */
        isView?: boolean;
        /**
         * 编辑按钮
         */
        isEditor?: boolean;
        /**
         * 删除按钮
         */
        isDelete?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/list`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/list`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryListPostRequestConfig: ZlbApiOfficeWorkSummaryListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/list`
 * @更新时间 `2023-12-26 16:22:04`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryListPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryListPostResponse>(
    prepare(zlbApiOfficeWorkSummaryListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryListPost.requestConfig = zlbApiOfficeWorkSummaryListPostRequestConfig;

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/601082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/detail`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryDetailPostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/601082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/detail`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作总结编号
     */
    workSummaryFormCode?: string;
    /**
     * 编号-业务展示用
     */
    businessCode?: string;
    /**
     * 操作人ID
     */
    operatorId?: number;
    /**
     * 操作人姓名
     */
    operatorName?: string;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门姓名
     */
    deptName?: string;
    /**
     * 日报时间
     */
    dailyTime?: number;
    /**
     * 标题
     */
    title?: string;
    /**
     * 工作总结内容
     */
    workSummary?: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 拒绝原因
     */
    rejectReason?: string;
    /**
     * 附件信息
     */
    zlbAttachmentROList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 附件类型
       */
      type?: string;
    }[];
    /**
     * 审批信息
     */
    workflowInfo?: {
      /**
       * 工作流的唯一key
       */
      workflowProcessKey?: string;
      /**
       * 工作流模型id
       */
      workflowModelId?: number;
      /**
       * 工作流版本
       */
      workflowVersion?: number;
      /**
       * 审核节点列表
       */
      auditNodeList?: {
        /**
         * 审核人列表
         */
        auditOperatorList?: {
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 审批意见
           */
          auditRemark?: string;
          /**
           * 审批状态：0-待审批，1-审批通过，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 签名附件
           */
          signAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 最新的个人历史签名附件
           */
          oneselfHistorySignAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
           */
          addAuditWay?: number;
          /**
           * 加签者
           */
          addAuditOperator?: string;
        }[];
        /**
         * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
         */
        userRangeType?: number;
        userRangeTypeNew?: number;
        /**
         * 动态审核人类型
         */
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        /**
         * 审核人数(总人数)
         */
        personCount?: number;
        /**
         * 审核状态：0-待审批，1-已审批，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 审核描述
         */
        auditDesc?: string;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳，3-抄送
         */
        eventType?: number;
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 节点key
         */
        nodeKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 策略
         * cn.gov.zcy.workflow.enums.CheckStrategyEnum
         */
        checkStrategy?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 机构
         */
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        /**
         * 常用审核人列表
         */
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        /**
         * 业务属性json
         */
        bizProperty?: string;
      }[];
      /**
       * 申请人操作人id
       */
      applyOperatorId?: number;
      /**
       * 申请人名称
       */
      applyOperatorName?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 申请备注
       */
      applyRemark?: string;
      /**
       * 是否能加签 0-否 1-是
       */
      isAddTaskAccess?: number;
      /**
       * 工作流是否开启签名：true-开启；false-未开启
       */
      isEnableSign?: boolean;
      /**
       * 签名配置：0-使用上次签名；1-每次重新签名；
       */
      signConfig?: number;
      /**
       * 实例当前节点业务属性
       */
      currentBizProperty?: string;
    };
    /**
     * 操作按钮权限
     */
    operateButton?: {
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/601082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/detail`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/601082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/detail`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryDetailPostRequestConfig: ZlbApiOfficeWorkSummaryDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [详情↗](http://yapi.cai-inc.com/project/6945/interface/api/601082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/detail`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryDetailPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryDetailPostResponse>(
    prepare(zlbApiOfficeWorkSummaryDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryDetailPost.requestConfig = zlbApiOfficeWorkSummaryDetailPostRequestConfig;

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/repeat/check`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryRepeatCheckPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标题
   */
  title?: string;
  /**
   * 日报时间
   */
  dailyTime?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchStart?: number;
  /**
   * 日报时间-搜索范围
   */
  dailyTimeSearchEnd?: number;
  /**
   * 状态
   */
  status?: number;
  /**
   * 编号
   */
  businessCode?: string;
  /**
   * 工作总结唯一单号
   */
  workSummaryFormCode?: string;
}

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/repeat/check`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryRepeatCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作总结编号
     */
    workSummaryFormCode?: string;
    /**
     * 编号-业务展示用
     */
    businessCode?: string;
    /**
     * 日报时间
     */
    dailyTime?: number;
    /**
     * 总结主图
     */
    title?: string;
    /**
     * 状态
     */
    status?: number;
    /**
     * 状态描述
     */
    statusDesc?: string;
    /**
     * 发起人ID
     */
    operatorId?: number;
    /**
     * 发起人姓名
     */
    operatorName?: string;
    /**
     * 发起人部门ID
     */
    deptId?: number;
    /**
     * 发起人部门名称
     */
    deptName?: string;
    /**
     * 发起时间
     */
    createTime?: number;
    /**
     * 最新修改时间
     */
    modifyTime?: number;
    /**
     * 操作按钮
     */
    buttonShowRO?: {
      /**
       * 查看按钮
       */
      isView?: boolean;
      /**
       * 编辑按钮
       */
      isEditor?: boolean;
      /**
       * 删除按钮
       */
      isDelete?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/repeat/check`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryRepeatCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/repeat/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/repeat/check`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryRepeatCheckPostRequestConfig: ZlbApiOfficeWorkSummaryRepeatCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/repeat/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryRepeatCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据日报时间查询↗](http://yapi.cai-inc.com/project/6945/interface/api/601090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/repeat/check`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryRepeatCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryRepeatCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryRepeatCheckPostResponse>(
    prepare(zlbApiOfficeWorkSummaryRepeatCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryRepeatCheckPost.requestConfig =
  zlbApiOfficeWorkSummaryRepeatCheckPostRequestConfig;

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/601098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/cancel`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryCancelPostRequest {
  /**
   * 编号
   */
  workSummaryFormCode: string;
  /**
   * 身份
   */
  identity?: string;
}

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/601098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/cancel`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryCancelPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/601098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/cancel`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/601098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/cancel`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryCancelPostRequestConfig: ZlbApiOfficeWorkSummaryCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [作废↗](http://yapi.cai-inc.com/project/6945/interface/api/601098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @请求头 `POST /zlb/api/office/work/summary/cancel`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryCancelPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryCancelPostResponse>(
    prepare(zlbApiOfficeWorkSummaryCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryCancelPost.requestConfig = zlbApiOfficeWorkSummaryCancelPostRequestConfig;

/**
 * 接口 [工作流审批，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/audit`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowAuditPostRequest {
  /**
   * 业务单号
   */
  bizId?: string;
  /**
   * 业务场景
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 审核意见
   */
  auditRemark?: string;
  /**
   * 审核状态：1-通过；2-驳回；
   */
  executeType: number;
  /**
   * 必填, 工作流类型Key
   */
  processDefineKey?: string;
  /**
   * 当前节点key
   */
  currentNodeKey: string;
  /**
   * 操作人
   */
  operatorId?: number;
  /**
   * 业务字段
   */
  context?: string;
  /**
   * 事件类型：0-审批，1-审核，2-出纳，3-抄送
   */
  eventType: number;
  /**
   * 签名附件
   */
  signAttachment?: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  };
}

/**
 * 接口 [工作流审批，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/audit`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作流审批，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/audit`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [工作流审批，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/audit`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryWorkflowAuditPostRequestConfig: ZlbApiOfficeWorkSummaryWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作流审批，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/audit`
 * @更新时间 `2023-12-26 16:22:05`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryWorkflowAuditPostResponse>(
    prepare(zlbApiOfficeWorkSummaryWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryWorkflowAuditPost.requestConfig =
  zlbApiOfficeWorkSummaryWorkflowAuditPostRequestConfig;

/**
 * 接口 [停止工作流，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/cancel`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowCancelPostRequest {
  bizId?: string;
  bizType?: string;
  subType?: string;
  /**
   * 可选, 备注：审批意见&撤回说明
   */
  remark?: string;
  operatorId?: number;
}

/**
 * 接口 [停止工作流，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/cancel`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowCancelPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [停止工作流，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/cancel`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryWorkflowCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/workflow/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [停止工作流，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/cancel`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryWorkflowCancelPostRequestConfig: ZlbApiOfficeWorkSummaryWorkflowCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/workflow/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryWorkflowCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [停止工作流，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/cancel`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryWorkflowCancelPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryWorkflowCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryWorkflowCancelPostResponse>(
    prepare(zlbApiOfficeWorkSummaryWorkflowCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryWorkflowCancelPost.requestConfig =
  zlbApiOfficeWorkSummaryWorkflowCancelPostRequestConfig;

/**
 * 接口 [查询工作流模板，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequest {
  /**
   * 流程key
   */
  processDefineKey?: string;
  /**
   * 业务Id
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 金额
   */
  amount?: number;
  /**
   * 事项预算
   */
  eventBudget?: number;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: number;
  /**
   * 操作人
   */
  operatorId?: number;
  /**
   * 同行人
   */
  accompanyOperatorIds?: number[];
  /**
   * 是否派车，1-派车，2-不派车
   */
  arrangeCar?: string;
  /**
   * 差旅类型
   */
  travelType?: number;
}

/**
 * 接口 [查询工作流模板，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
         */
        addAuditWay?: number;
        /**
         * 加签者
         */
        addAuditOperator?: string;
      }[];
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 动态审核人类型
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳，3-抄送
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 策略
       * cn.gov.zcy.workflow.enums.CheckStrategyEnum
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 机构
       */
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      /**
       * 业务属性json
       */
      bizProperty?: string;
    }[];
    /**
     * 工作流的唯一key
     */
    workflowProcessKey?: string;
    /**
     * 工作流模型id
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询工作流模板，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/workflow/getTemplate',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询工作流模板，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequestConfig: ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/workflow/getTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryWorkflowGetTemplatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询工作流模板，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/getTemplate`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryWorkflowGetTemplatePost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryWorkflowGetTemplatePostResponse>(
    prepare(zlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryWorkflowGetTemplatePost.requestConfig =
  zlbApiOfficeWorkSummaryWorkflowGetTemplatePostRequestConfig;

/**
 * 接口 [加签，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequest {
  /**
   * 业务标识
   */
  bizId: string;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 必填, 业务场景
   */
  bizType: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  remark?: string;
  /**
   * 业务上下文
   */
  context?: string;
  operatorId?: number;
}

/**
 * 接口 [加签，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export interface ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作流的唯一key
     */
    workflowProcessKey?: string;
    /**
     * 工作流模型id
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
         */
        addAuditWay?: number;
        /**
         * 加签者
         */
        addAuditOperator?: string;
      }[];
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 动态审核人类型
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳，3-抄送
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 策略
       * cn.gov.zcy.workflow.enums.CheckStrategyEnum
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 机构
       */
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      /**
       * 业务属性json
       */
      bizProperty?: string;
    }[];
    /**
     * 申请人操作人id
     */
    applyOperatorId?: number;
    /**
     * 申请人名称
     */
    applyOperatorName?: string;
    /**
     * 申请时间
     */
    applyTime?: string;
    /**
     * 申请备注
     */
    applyRemark?: string;
    /**
     * 是否能加签 0-否 1-是
     */
    isAddTaskAccess?: number;
    /**
     * 工作流是否开启签名：true-开启；false-未开启
     */
    isEnableSign?: boolean;
    /**
     * 签名配置：0-使用上次签名；1-每次重新签名；
     */
    signConfig?: number;
    /**
     * 实例当前节点业务属性
     */
    currentBizProperty?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加签，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
type ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/6945',
    '',
    '',
    '/zlb/api/office/work/summary/workflow/addCounterSign',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
const zlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequestConfig: ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/zlb/api/office/work/summary/workflow/addCounterSign',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiOfficeWorkSummaryWorkflowAddCounterSignPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签，暂停使用，直接使用插件的rest接口↗](http://yapi.cai-inc.com/project/6945/interface/api/601130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作总结↗](http://yapi.cai-inc.com/project/6945/interface/api/cat_54482)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/office/work/summary/workflow/addCounterSign`
 * @更新时间 `2023-12-26 16:22:06`
 * @项目ID 6945
 */
export const zlbApiOfficeWorkSummaryWorkflowAddCounterSignPost = /*#__PURE__*/ (
  requestData: ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiOfficeWorkSummaryWorkflowAddCounterSignPostResponse>(
    prepare(zlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiOfficeWorkSummaryWorkflowAddCounterSignPost.requestConfig =
  zlbApiOfficeWorkSummaryWorkflowAddCounterSignPostRequestConfig;

/* prettier-ignore-end */
